// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  ContentType,
} from "./types";

export default {
  dtmi: __t.string(),
  get contentType() {
    return ContentType;
  },
  oldName: __t.string(),
  newName: __t.string(),
  parentRelationshipName: __t.option(__t.string()),
};
